import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import classnames from 'classnames';
import React, { useMemo } from 'react';
import styles from './switch-task.module.scss';
import { Icon } from '../icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SwitchTask = function SwitchTask(_ref) {
  var _classnames;

  var className = _ref.className,
      dark = _ref.dark,
      items = _ref.items,
      onClickLockedItem = _ref.onClickLockedItem;
  var activeIndex = useMemo(function () {
    return items.findIndex(function (item) {
      return item.active;
    });
  }, [items]);
  return /*#__PURE__*/_jsx("ul", {
    "data-index": activeIndex,
    "data-total": items.length,
    className: classnames(className, styles.list, (_classnames = {}, _defineProperty(_classnames, styles.dark, dark), _defineProperty(_classnames, styles.activeSecond, activeIndex === 1), _classnames)),
    children: items.map(function (item) {
      return /*#__PURE__*/_jsx("li", {
        className: styles.item,
        children: /*#__PURE__*/_jsxs("button", {
          id: item.id,
          type: "button",
          disabled: item.disabled,
          onClick: item.locked ? onClickLockedItem : item.onClick,
          className: classnames(styles.button, _defineProperty({}, styles.active, item.active)),
          children: [item.locked || item.icon ? /*#__PURE__*/_jsx(Icon, {
            name: item.locked ? 'lock' : item.icon,
            width: 20,
            height: 20,
            className: styles.icon
          }) : null, item.title]
        })
      }, item.title);
    })
  });
};